export const XAPI_URL = process.env.REACT_APP_XAPI_URL
export const SOLVER_URL = process.env.REACT_APP_SOLVER_URL
